/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsSerialNumberListItem
 */
export interface IdentityMelcoModelsSerialNumberListItem {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    serial_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    product_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    product_level_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    subscription_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    referral_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    batch?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    cancelled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    version_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    version_id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    type?: number;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    referral?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    subscription_start_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsSerialNumberListItem
     */
    sub_cancelled_date?: Date | null;
}

export function IdentityMelcoModelsSerialNumberListItemFromJSON(json: any): IdentityMelcoModelsSerialNumberListItem {
    return IdentityMelcoModelsSerialNumberListItemFromJSONTyped(json, false);
}

export function IdentityMelcoModelsSerialNumberListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsSerialNumberListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'serial_number': !exists(json, 'serial_number') ? undefined : json['serial_number'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
        'product_level_name': !exists(json, 'product_level_name') ? undefined : json['product_level_name'],
        'subscription_code': !exists(json, 'subscription_code') ? undefined : json['subscription_code'],
        'referral_code': !exists(json, 'referral_code') ? undefined : json['referral_code'],
        'batch': !exists(json, 'batch') ? undefined : json['batch'],
        'cancelled': !exists(json, 'cancelled') ? undefined : json['cancelled'],
        'version_number': !exists(json, 'version_number') ? undefined : json['version_number'],
        'version_id': !exists(json, 'version_id') ? undefined : json['version_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'referral': !exists(json, 'referral') ? undefined : json['referral'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'subscription_start_date': !exists(json, 'subscription_start_date') ? undefined : (json['subscription_start_date'] === null ? null : new Date(json['subscription_start_date'])),
        'sub_cancelled_date': !exists(json, 'sub_cancelled_date') ? undefined : (json['sub_cancelled_date'] === null ? null : new Date(json['sub_cancelled_date'])),
    };
}

export function IdentityMelcoModelsSerialNumberListItemToJSON(value?: IdentityMelcoModelsSerialNumberListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'serial_number': value.serial_number,
        'product_code': value.product_code,
        'product_name': value.product_name,
        'product_level_name': value.product_level_name,
        'subscription_code': value.subscription_code,
        'referral_code': value.referral_code,
        'batch': value.batch,
        'cancelled': value.cancelled,
        'version_number': value.version_number,
        'version_id': value.version_id,
        'type': value.type,
        'referral': value.referral,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'subscription_start_date': value.subscription_start_date === undefined ? undefined : (value.subscription_start_date === null ? null : value.subscription_start_date.toISOString()),
        'sub_cancelled_date': value.sub_cancelled_date === undefined ? undefined : (value.sub_cancelled_date === null ? null : value.sub_cancelled_date.toISOString()),
    };
}


